import { render, staticRenderFns } from "./FieldWrapperDisabled.vue?vue&type=template&id=02c1a648&scoped=true&"
import script from "./FieldWrapperDisabled.vue?vue&type=script&lang=js&"
export * from "./FieldWrapperDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1a648",
  null
  
)

export default component.exports